import {mapActions} from "vuex";
import {store} from "../_store"

export function isUserOnline() {
    return  (navigator.onLine)
}

export function checkOfflineData() {
    if(navigator.onLine && localStorage.getItem('offlineData')){
        console.log('Test');

        // Send cached data
        var data = JSON.parse(localStorage.getItem('offlineData'));

        data.forEach(apiCall => {
            store.dispatch('account/updateUserInfo', apiCall.dataObject[0].user);
        })

        localStorage.removeItem('offlineData');
    }
}
